/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholder_BodyInputs */

const en_placeholder_body = /** @type {(inputs: Placeholder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon.`)
};

const de_placeholder_body = /** @type {(inputs: Placeholder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommt bald.`)
};

/**
* | output |
* | --- |
* | "Coming soon." |
*
* @param {Placeholder_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const placeholder_body = /** @type {((inputs?: Placeholder_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholder_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_placeholder_body(inputs)
	return en_placeholder_body(inputs)
});